<template>
  <div style="display: inline-block;">
    <span @click="show()">
      <slot></slot>
    </span>
    <el-dialog class="el-dialog-sm el-dialog-sm-h3" :close-on-click-modal="false" :modal="!mobiletype" :visible.sync="dialogFormVisible">
      <div :class="{mobile_upload_order:mobiletype}">
      <h3 class="text-center">分享任务</h3>
      <el-input :rows="5" type="textarea" :readonly="true" v-model="shareUrl"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button v-clipboard:copy="shareUrl" :type="'info'" style="margin-top:10px;margin-bottom:10px;" class="block">复 制</el-button>
      </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../../services/api.js'
let _ = require('lodash')

export default {
  name: 'OrderShare',
  props: ['order','mobiletype'],
  components: {
  },
  computed: {
  },
  data () {
    return {
      dialogFormVisible: false,
      shareUrl: null
    }
  },
  methods: {
    show () {
      this.shareUrl = `${window.location.origin}/order/share?id=${this.order.id}&random=${this.order.random}`
      this.dialogFormVisible = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .dialog-form {
    padding-bottom: 40px;
  }
  .tip {
    font-size:16px;
    color:rgba(136,136,136,1);
    line-height:24px;
    margin-bottom: 5px;
  }
  .add-tip {
    font-size:14px;
    color:rgba(102,102,102,1);
    line-height:24px;
    margin-left: 5px;
  }
  .back {
    float: left;
    color: #C0C4CC;
    font-size: 26px;
    line-height: 30px;
    cursor: pointer;
  }

  .select-address {
    padding-bottom: 7px;
    border-bottom: 1px solid #CDCDCD;
    margin-bottom: 10px;
  }
   .mobile_upload_order {
    padding: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/list/OrderShare.vue